module.exports = __webpack_public_path__ + "img/Foto_profilo.7327492f.jpg";